import React, { useState, useEffect } from "react";
import { NavLink,useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import { FaPhoneAlt } from "react-icons/fa";

const Header = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [showProductsSubmenu, setShowProductsSubmenu] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Styles
  const barStyle = {
    width: "100%",
    background: "transparent",
    color: "#fff",
    fontWeight: "bold",
    fontSize: isMobile ? "0.7rem" : "1.05rem",
    overflow: "hidden",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 9999,
    height: isMobile ? "1.5rem" : "2.2rem",
    display: "flex",
    alignItems: "center",
  };

  const marqueeStyle = {
    // background: "#008dd2",
    background: "#13499C",
    display: "inline-block",
    whiteSpace: "nowrap",
    animation: "scroll-left 50s linear infinite",
  };

  const headerStyle = {    
    background: "#13499C",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    color: "#fff",
    padding: isMobile ? "0.5rem" : "1rem",
    marginTop: isMobile ? "0rem" : "0rem",
  };

  const headerContentStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.5rem",
    width: "100%",
  };

  const logoContainerStyle = {
    display: "flex",
    alignItems: "center",
    gap: isMobile ? "0.5rem" : "1rem",
    flexDirection: isMobile ? "column" : "row",
  };

  const logoStyle = {
    height: isMobile ? "50px" : "100px",
    width: isMobile ? "150px" : "400px",
    marginRight: isMobile ? "0" : "1rem",
  };

  const titleStyle = {
    fontSize: isMobile ? "1rem" : "2.5rem",
    margin: 0,
    textAlign: "center",
  };

  const navStyle = {
    display: "flex",
    gap: isMobile ? "0.5rem" : "1.5rem",
    marginTop: "0.25rem",
    flexWrap: "wrap",
    justifyContent: "center",
  };

  const topbar_wrap = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: "8px 16px",
  };

  const topSocialStyle = {
    display: "flex",
    gap: "0.5rem",
    listStyle: "none",
    padding: 0,
    margin: 0,
  };


  const submenuWrapperStyle = { position: "relative", display: "inline-block" };
  const submenuStyle = {
    display: showProductsSubmenu ? "block" : "none",
    position: isMobile ? "static" : "absolute",
    top: isMobile ? undefined : "100%",
    left: 0,
    background: "#fff",
    minWidth: 180,
    boxShadow: isMobile ? "none" : "0 2px 10px rgba(0,0,0,0.10)",
    borderRadius: isMobile ? 0 : "0 0 0px 0px",
    zIndex: 100,
  };
  const submenuLinkStyle = {
    display: "block",  
    padding: "0.75rem 1rem",
    textDecoration: "none",
    whiteSpace: "nowrap",
  };
  const handleLogoClick = () => {
    navigate('/');
  };


  return (
    
    <header style={headerStyle}>
      <style>
        {`
        .circle-icon {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: transparent;         /* No background */
        transition: border 0.2s, color 0.2s;
        border: 2px solid transparent;   /* No border by default */
        background:rgba(0,0,0,0.10);
        color: #fff; /* Default icon color */
      }

      .circle-icon i {
        color: #fff;
        font-size: 1.2rem;
        transition: color 0.2s;
      }

      .circle-icon:hover {
        border: 2px solid #fff;          /* White outline on hover */
        background: transparent;         /* Still no background */
        cursor: pointer;
      }

        `}
      </style>
      <div style={barStyle}>
        <div style={{ width: "100%", overflow: "hidden" }}>
          <span style={marqueeStyle}>
            <FaPhoneAlt style={{ marginRight: 8 }} />
            Call us: +91-96117 03676 &nbsp; | &nbsp; +91-96636-39384 &nbsp; | &nbsp; Email: marketing@akruthipeb.com
          </span>
        </div>
        <style>
          {`
            @keyframes scroll-left {
              0% { transform: translateX(100%); }
              100% { transform: translateX(-100%); }
            }
          `}
        </style>
      </div>
      <div className="container">
        <div style={topbar_wrap}>
          {!isMobile && (
            <div className="left">
             
            </div>
          )}
          <div className="right">
            <div className="top-social">
            <ul style={topSocialStyle}>
  <li>
    <a target="_blank" href="https://in.linkedin.com/company/akruthi-engineered-building-solution?trk=public_profile_topcard-current-company"  rel="noopener noreferrer">
    <div className="circle-icon">
  <i className="fab fa-linkedin-in" ></i>
</div>
    </a>
  </li>
  <li>
  <a target="_blank" href="https://www.youtube.com/@ravis1403" rel="noopener noreferrer">
    <div className="circle-icon">
      <i className="fab fa-facebook-f" style={{ color: "#fff" }}></i>
    </div>
  </a>
</li>
  <li>
    <a target="_blank" href="https://www.youtube.com/@ravis1403" el="noopener noreferrer">
    <div className="circle-icon">
      <i className="fab fa-youtube" ></i>
      </div>
    </a>
  </li>
</ul>
            </div>
          </div>
        </div>
      </div>


      <div style={headerContentStyle}>
  <div style={logoContainerStyle}>
    <img src={logo} alt="Akruthi Logo" style={logoStyle} onClick={handleLogoClick} />
    <h1 style={titleStyle}>Akruthi Engineered Building Solutions</h1>
  </div>
  <nav className="nav-menu" style={navStyle}>
    <div className="menu-item">
      <NavLink to="/" className="menu-link">Home</NavLink>
    </div>
    <div className="menu-item">
      <NavLink to="/about" className="menu-link">About</NavLink>
    </div>
    <div className="menu-item">
      <NavLink to="/products" className="menu-link">Products</NavLink>
    </div>
    <div
      className="menu-item submenu-wrapper"
      style={submenuWrapperStyle}
      onMouseEnter={() => !isMobile && setShowProductsSubmenu(true)}
      onMouseLeave={() => !isMobile && setShowProductsSubmenu(false)}
      onClick={() => isMobile && setShowProductsSubmenu((v) => !v)}
      tabIndex={0}>

      <NavLink to="/services" className="menu-link">
        Services
      </NavLink>
      {showProductsSubmenu && (
        <div className="submenu" style={submenuStyle}>
          <NavLink to="/services?service=Design" className="submenu-link" style={submenuLinkStyle}>
          Design
          </NavLink>
          <NavLink to="/services?service=Fabrication" className="submenu-link" style={submenuLinkStyle}>
          Fabrication
          </NavLink>
          <NavLink to="/services?service=Installation" className="submenu-link" style={submenuLinkStyle}>
          Installation
          </NavLink>
          <NavLink to="/services?service=Safety" className="submenu-link" style={submenuLinkStyle}>
          Safety
          </NavLink>
        </div>
      )}
    </div>
    <div className="menu-item">
      <NavLink to="/projects" className="menu-link">Projects</NavLink>
    </div>
    <div className="menu-item">
      <NavLink to="/clients" className="menu-link">Clients</NavLink>
    </div>
    <div className="menu-item">
      <NavLink to="/carrer" className="menu-link">Careers</NavLink>
    </div>
    <div className="menu-item">
      <NavLink to="/contact" className="menu-link">Contact</NavLink>
    </div>
  </nav>
</div>

    </header>
  );
};

export default Header;
